(function(){
var $=function(s,r){return (r||document).querySelector(s);},$$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};
var pad2=function(n){return n<10?'0'+n:''+n;};
function money(c){var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';var v=c/100;try{return new Intl.NumberFormat('en-US',{style:'currency',currency:cur,minimumFractionDigits:v%1?2:0}).format(v);}catch(e){return '$'+v;}}
/* Countdown: one end date (Announcement bar setting) drives the bar and the offer boxes */
function tick(){
  var r=$('[data-countdown-end]');if(!r)return;
  var t=new Date(r.getAttribute('data-countdown-end')).getTime();if(isNaN(t))return;
  var el=$('#countdown'),dd=$('#ocDays'),hh=$('#ocHours'),mm=$('#ocMins'),ss=$('#ocSecs');
  var diff=t-Date.now();
  if(diff<=0){if(el)el.textContent='Ending soon';if(dd){dd.textContent=hh.textContent=mm.textContent=ss.textContent='00';}return;}
  var d=Math.floor(diff/864e5),h=Math.floor(diff%864e5/36e5),m=Math.floor(diff%36e5/6e4),s=Math.floor(diff%6e4/1e3);
  if(el)el.textContent=d+'d '+h+'h '+m+'m '+s+'s';
  if(dd){dd.textContent=pad2(d);hh.textContent=pad2(h);mm.textContent=pad2(m);ss.textContent=pad2(s);}
}
tick();setInterval(tick,1000);
/* Cart drawer */
function openDrawer(item,opt){
  var ov=$('#cartOverlay'),dr=$('#cartDrawer');if(!ov||!dr)return;
  if(item){
    var n=$('#cartItemName'),v=$('#cartItemVariant'),p=$('#cartItemPrice'),im=$('#cartItemImg');
    if(n)n.textContent=item.product_title||item.title||'';
    if(v)v.textContent=(opt&&opt.dataset.name)||item.variant_title||'';
    if(p)p.textContent=money(item.final_line_price!=null?item.final_line_price:item.line_price||0);
    var u=item.featured_image&&item.featured_image.url||item.image;if(im&&u)im.src=u;
  }
  ov.classList.add('active');dr.classList.add('active');
}
function closeDrawer(){var ov=$('#cartOverlay'),dr=$('#cartDrawer');if(ov)ov.classList.remove('active');if(dr)dr.classList.remove('active');}
function selectedOpt(){return $('.price-option.selected')||$('.price-option');}
function addSelected(){
  var opt=selectedOpt(),btn=$('#addToCartBtn');
  if(!opt||!opt.dataset.variantId){if(btn&&btn.getAttribute('href')&&btn.getAttribute('href')!=='#offer')window.location.href=btn.getAttribute('href');else{var o=$('#offer');if(o)o.scrollIntoView({behavior:'smooth'});}return;}
  if(opt.dataset.available==='false')return;
  if(btn)btn.style.opacity='.7';
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(opt.dataset.variantId),quantity:Number(opt.dataset.qty||1)}]})})
   .then(function(r){if(!r.ok)throw new Error('add failed');return r.json();})
   .then(function(d){if(btn)btn.style.opacity='';openDrawer(d.items?d.items[0]:d,opt);})
   .catch(function(){window.location.href='/cart';});
}
function setLabel(opt){
  var btn=$('#addToCartBtn');if(!btn||!opt)return;
  if(opt.dataset.available==='false'){btn.textContent=btn.dataset.soldOutLabel||'Sold out';return;}
  btn.textContent=(btn.dataset.label||'Add to cart — [price]').replace('[price]',opt.dataset.price||'');
}
document.addEventListener('click',function(e){
  var t=e.target;
  var tab=t.closest&&t.closest('.ing-tab');
  if(tab){$$('.ing-tab').forEach(function(x){x.classList.remove('active');});$$('.ing-panel').forEach(function(x){x.classList.remove('active');});tab.classList.add('active');var pn=$('.ing-panel[data-panel="'+tab.dataset.tab+'"]');if(pn)pn.classList.add('active');return;}
  var th=t.closest&&t.closest('.thumb');
  if(th){$$('.thumb').forEach(function(x){x.classList.remove('active');});th.classList.add('active');var mi=$('#galleryMainImg');if(mi)mi.setAttribute('src',th.dataset.img);return;}
  var po=t.closest&&t.closest('.price-option');
  if(po){$$('.price-option').forEach(function(o){o.classList.remove('selected');var r=$('input[type="radio"]',o);if(r)r.checked=false;});po.classList.add('selected');var rd=$('input[type="radio"]',po);if(rd)rd.checked=true;setLabel(po);return;}
  if(t.closest&&(t.closest('#addToCartBtn')||t.closest('#ingCartBtn'))){e.preventDefault();addSelected();return;}
  if(t.closest&&(t.closest('#cartCloseBtn')||t.closest('#cartViewOfferBtn'))){closeDrawer();return;}
  if(t.id==='cartOverlay'){closeDrawer();return;}
  var rb=t.closest&&t.closest('#reviewsToggleBtn');
  if(rb){
    var cards=$$('.testi-card[data-batch]'),max=1;cards.forEach(function(c){max=Math.max(max,parseInt(c.dataset.batch,10));});
    if(!rb.dataset.more)rb.dataset.more=rb.textContent;
    var cur=parseInt(rb.dataset.cur||'1',10);
    var less=rb.dataset.less||'Read Less Reviews ↑';
    if(cur<max){cur++;$$('.testi-card[data-batch="'+cur+'"]').forEach(function(c){c.classList.remove('testi-hidden');});rb.textContent=cur===max?less:rb.dataset.more;}
    else{cur=1;cards.forEach(function(c){c.classList.add('testi-hidden');});rb.textContent=rb.dataset.more;var ts=$('.testimonials');if(ts)ts.scrollIntoView({behavior:'smooth',block:'start'});}
    rb.dataset.cur=cur;
  }
});
document.addEventListener('DOMContentLoaded',function(){var s=selectedOpt();if(s)setLabel(s);var rb=$('#reviewsToggleBtn');if(rb){rb.dataset.more=rb.textContent;}});
/* Ritual timeline: scroll-driven connecting line */
var ticking=false;
function timeline(){
  ticking=false;
  var line=$('.rt-line'),fill=$('#rtLineProgress');if(!line||!fill)return;
  var items=$$('.rt-item',line);if(items.length<2)return;
  var c=items.map(function(it){var dot=$('.rt-dot',it);return it.offsetTop+dot.offsetTop+dot.offsetHeight/2;});
  var first=c[0],last=c[c.length-1],minSeg=c[1]-first,total=last-first;if(total<=0)return;
  var rect=line.getBoundingClientRect(),vh=window.innerHeight||document.documentElement.clientHeight;
  var st=vh*.85,en=vh*.25,tot=rect.height+(st-en),pr=tot>0?(st-rect.top)/tot:0;
  pr=Math.max(0,Math.min(1,pr));
  fill.style.top=first+'px';fill.style.height=(minSeg+pr*(total-minSeg))+'px';
}
function onS(){if(!ticking){ticking=true;requestAnimationFrame(timeline);}}
window.addEventListener('scroll',onS,{passive:true});window.addEventListener('resize',onS);
window.addEventListener('load',timeline);document.addEventListener('shopify:section:load',timeline);
timeline();
})();
